import {Range} from "../../../../../../pkg/slate.js";
export const isCollapsed = (range) => !!range && Range.isCollapsed(range);
